import React from 'react'

export const BlitzLogo = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='71' height='32' viewBox='0 0 71 32' fill='none'>
      <path
        d='M0.0438803 31.4412L3.62891 5.93237H8.98708L7.63919 15.5231H7.80271C8.10985 15.0083 8.52297 14.4851 9.04208 13.9537C9.57073 13.414 10.2207 12.9656 10.992 12.6085C11.7729 12.2431 12.7042 12.0605 13.7859 12.0605C15.1946 12.0605 16.443 12.4258 17.531 13.1565C18.6201 13.879 19.4184 14.9709 19.9258 16.4323C20.4343 17.8855 20.5345 19.7081 20.2264 21.9003C19.9265 24.0343 19.3253 25.8362 18.4227 27.3059C17.5298 28.7674 16.4348 29.8759 15.1379 30.6316C13.8506 31.3789 12.4732 31.7525 11.0058 31.7525C9.96598 31.7525 9.10526 31.5823 8.42359 31.2419C7.75031 30.9014 7.21925 30.4738 6.83042 29.959C6.44275 29.4358 6.16467 28.9085 5.99619 28.3771H5.75721L5.32659 31.4412H0.0438803ZM6.63324 21.8754C6.47336 23.013 6.49322 24.0052 6.69283 24.8522C6.89243 25.6992 7.26084 26.3593 7.79806 26.8326C8.33645 27.2976 9.03748 27.5301 9.90116 27.5301C10.7732 27.5301 11.5444 27.2935 12.2146 26.8202C12.8861 26.3386 13.4364 25.6743 13.8657 24.8273C14.3046 23.972 14.6022 22.9881 14.7585 21.8754C14.9138 20.771 14.8952 19.7995 14.7028 18.9608C14.5104 18.1221 14.1456 17.4661 13.6084 16.9928C13.0711 16.5195 12.3623 16.2829 11.4819 16.2829C10.6098 16.2829 9.8398 16.5112 9.17188 16.9679C8.51234 17.4246 7.96432 18.0723 7.52781 18.911C7.09131 19.7496 6.79312 20.7378 6.63324 21.8754Z'
        fill='white'
      />
      <path d='M30.3414 5.93237L26.7564 31.4412H21.3982L24.9832 5.93237H30.3414Z' fill='white' />
      <path d='M29.986 31.4412L32.6748 12.3096H38.0329L35.3442 31.4412H29.986Z' fill='white' />
      <path
        d='M51.5387 12.3096L50.9785 16.2953H39.344L39.9042 12.3096H51.5387ZM43.1897 7.72596H48.5479L46.0411 25.5622C45.9723 26.0521 45.9941 26.4341 46.1065 26.7081C46.2201 26.9738 46.4035 27.1606 46.6566 27.2686C46.9182 27.3765 47.2292 27.4305 47.5898 27.4305C47.8413 27.4305 48.0958 27.4097 48.3532 27.3682C48.6118 27.3184 48.8099 27.281 48.9475 27.2561L49.2354 31.2045C48.9554 31.2875 48.5646 31.383 48.0631 31.491C47.5604 31.6072 46.9593 31.6778 46.2598 31.7027C44.9615 31.7525 43.8534 31.5823 42.9356 31.192C42.0261 30.8018 41.3608 30.1956 40.9397 29.3736C40.5186 28.5515 40.4003 27.5135 40.5849 26.2597L43.1897 7.72596Z'
        fill='white'
      />
      <path
        d='M51.1771 31.4412L51.6217 28.2775L62.71 16.6814L62.7292 16.5444H53.5977L54.1929 12.3096H69.7768L69.292 15.7597L58.8225 27.0693L58.8033 27.2063H68.0103L67.4151 31.4412H51.1771Z'
        fill='white'
      />
      <path
        d='M33.6484 5.77854L38.5419 0.247314L37.0739 4.90519L39.8468 5.19631L34.6271 10.8731L36.2583 6.36078L33.6484 5.77854Z'
        fill='white'
      />
    </svg>
  )
}

export const BoltLogo = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='72' height='32' viewBox='0 0 72 32' fill='none'>
      <path
        d='M5.29609 3L1 28.8777H12.6121C14.5159 28.8777 16.1922 28.566 17.641 27.9426C19.0899 27.3108 20.2566 26.4516 21.1411 25.365C22.034 24.2699 22.5942 23.0274 22.8216 21.6375C23.0322 20.3992 22.9438 19.321 22.5563 18.4028C22.1688 17.4762 21.5707 16.7559 20.762 16.2421C20.0321 15.7734 19.2006 15.5009 18.2674 15.4247L7.26975 26.5881L10.8026 17.4665L5.15002 16.2895L15.7487 5.10818L12.5691 14.524L18.3393 15.0894C19.2023 14.8801 19.9972 14.5483 20.7241 14.094C21.5328 13.5802 22.2067 12.94 22.7458 12.1734C23.2934 11.3984 23.6556 10.5224 23.8325 9.54523C24.0515 8.24798 23.9083 7.10656 23.4029 6.12099C22.9059 5.13541 22.0466 4.36885 20.8252 3.82131C19.6038 3.27377 18.0243 3 16.0869 3H5.29609ZM52.8374 28.8777L57.1335 3H50.9547L46.6586 28.8777H52.8374ZM70.1892 14.0182L70.96 9.46942H67.4458L68.2181 4.81952H62.0393L61.2701 9.46942H58.7161L57.9454 14.0182H60.5176L58.9562 23.457C58.7203 24.7627 58.7962 25.8493 59.1836 26.717C59.5796 27.5846 60.2577 28.2248 61.218 28.6376C62.1867 29.0419 63.4124 29.2146 64.8949 29.1556C65.6278 29.122 66.268 29.0419 66.8155 28.9156C67.3715 28.7976 67.8137 28.6923 68.1423 28.5997L67.9401 24.1393C67.7969 24.1646 67.5863 24.2025 67.3083 24.253C67.0303 24.3036 66.7776 24.3289 66.5502 24.3289C66.2217 24.3289 65.9437 24.2825 65.7162 24.1899C65.4972 24.0888 65.3456 23.9245 65.2614 23.6971C65.1855 23.4612 65.1771 23.1537 65.2361 22.7747L66.6904 14.0182H70.1892ZM33.6756 29.2441C31.6286 29.2441 29.9397 28.8229 28.6087 27.9805C27.2862 27.1382 26.3554 25.9631 25.8163 24.4552C25.2771 22.9474 25.1718 21.1952 25.5004 19.1988C25.8289 17.2108 26.507 15.4671 27.5347 13.9677C28.5624 12.4683 29.8765 11.3016 31.477 10.4676C33.0775 9.63368 34.8928 9.2167 36.9229 9.2167C38.9615 9.2167 40.642 9.63789 41.9645 10.4803C43.2955 11.3226 44.2305 12.4977 44.7696 14.0056C45.3172 15.5134 45.4267 17.2698 45.0981 19.2746C44.7696 21.2626 44.0873 23.0063 43.0512 24.5058C42.0151 25.9968 40.701 27.1592 39.1089 27.9932C37.5168 28.8271 35.7057 29.2441 33.6756 29.2441ZM34.3705 24.5816C35.1287 24.5816 35.8068 24.3541 36.4049 23.8992C37.0114 23.4444 37.521 22.8084 37.9338 21.9913C38.3465 21.1742 38.6414 20.2265 38.8183 19.1483C38.9952 18.0869 39.012 17.1561 38.8688 16.3558C38.734 15.5471 38.4476 14.9196 38.0096 14.4731C37.5716 14.0182 36.9777 13.7908 36.228 13.7908C35.4698 13.7908 34.7875 14.0224 34.181 14.4857C33.5745 14.9406 33.0649 15.5766 32.6521 16.3937C32.2478 17.2024 31.9571 18.1501 31.7803 19.2367C31.6034 20.2981 31.5823 21.2289 31.7171 22.0292C31.8519 22.8294 32.1425 23.457 32.5889 23.9119C33.0354 24.3583 33.6293 24.5816 34.3705 24.5816Z'
        fill='white'
      />
    </svg>
  )
}

type colortype = {
  color?: string
}
export const HomeIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.91998 4.03463L9.9202 4.03481L9.91998 4.03463ZM10 4.10131L16.125 9.20548V16.125H12.4687V12.3438C12.4687 11.5844 11.8531 10.9688 11.0937 10.9688H8.90625C8.14686 10.9688 7.53125 11.5844 7.53125 12.3438V16.125H3.875V9.20548L10 4.10131ZM16.17 9.24296C16.1699 9.24289 16.1698 9.24282 16.1697 9.24274L16.17 9.24296ZM9.11975 2.88229C9.62966 2.45737 10.3703 2.45737 10.8803 2.88229L17.1303 8.09063C17.4437 8.35187 17.625 8.73886 17.625 9.14693V16.25C17.625 17.0094 17.0094 17.625 16.25 17.625H12.3437C11.5844 17.625 10.9687 17.0094 10.9687 16.25V12.4688H9.03125V16.25C9.03125 17.0094 8.41564 17.625 7.65625 17.625H3.75C2.99061 17.625 2.375 17.0094 2.375 16.25V9.14693C2.375 8.73886 2.55626 8.35187 2.86975 8.09063L9.11975 2.88229Z'
        fill={color}
      />
    </svg>
  )
}

export const ManageContentIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M7.45257 3.19644C7.45257 2.81181 7.76438 2.5 8.14901 2.5H16.8928C17.9185 2.5 18.75 3.33149 18.75 4.35718V11.97C18.75 12.3547 18.4382 12.6665 18.0536 12.6665C17.6689 12.6665 17.3571 12.3547 17.3571 11.97V4.35718C17.3571 4.10076 17.1492 3.89289 16.8928 3.89289H8.14901C7.76438 3.89289 7.45257 3.58108 7.45257 3.19644Z'
        fill={color}
      />
      <path
        d='M11.1504 11.1977C11.4914 10.9676 11.4914 10.4657 11.1504 10.2356L9.05405 8.8207C8.66859 8.56055 8.14901 8.83673 8.14901 9.30176V12.1315C8.14901 12.5965 8.66859 12.8727 9.05405 12.6125L11.1504 11.1977Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.5 6.86392C2.5 5.83823 3.33149 5.00674 4.35718 5.00674H14.4164C15.4421 5.00674 16.2736 5.83823 16.2736 6.86392V14.5694C16.2736 15.5951 15.4421 16.4266 14.4164 16.4266H4.35718C3.33149 16.4266 2.5 15.5951 2.5 14.5694V6.86392ZM4.35718 6.39963C4.10076 6.39963 3.89289 6.6075 3.89289 6.86392V14.5694C3.89289 14.8258 4.10076 15.0337 4.35718 15.0337H14.4164C14.6728 15.0337 14.8807 14.8258 14.8807 14.5694V6.86392C14.8807 6.6075 14.6728 6.39963 14.4164 6.39963H4.35718Z'
        fill={color}
      />
    </svg>
  )
}

export const RoleManagementIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      data-testid='role-management-icon-svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.54499 3.47339C7.4754 3.47339 6.60833 4.34046 6.60833 5.41005C6.60833 6.47964 7.4754 7.34671 8.54499 7.34671C9.61458 7.34671 10.4817 6.47964 10.4817 5.41005C10.4817 4.34046 9.61458 3.47339 8.54499 3.47339ZM5.10833 5.41005C5.10833 3.51204 6.64698 1.97339 8.54499 1.97339C10.443 1.97339 11.9817 3.51204 11.9817 5.41005C11.9817 7.03618 10.8523 8.39852 9.33507 8.75546C10.2689 8.89164 11.1405 9.23545 11.9077 9.73994C12.2538 9.96751 12.3499 10.4326 12.1224 10.7787C11.8948 11.1248 11.4297 11.2209 11.0836 10.9933C10.3049 10.4813 9.39821 10.19 8.43085 10.19C5.62734 10.19 3.25 12.6809 3.25 15.888C3.25 16.3641 3.63593 16.75 4.112 16.75H9.77418C10.1884 16.75 10.5242 17.0858 10.5242 17.5C10.5242 17.9143 10.1884 18.25 9.77418 18.25H4.112C2.8075 18.25 1.75 17.1925 1.75 15.888C1.75 12.2408 4.29564 9.14225 7.67372 8.73531C6.19761 8.34961 5.10833 7.00704 5.10833 5.41005ZM14 11.4059C14.4254 11.1603 14.9496 11.1603 15.375 11.4059L17.1857 12.4513C17.6111 12.697 17.8732 13.1509 17.8732 13.6421V15.7329C17.8732 16.2242 17.6111 16.6781 17.1857 16.9237L15.375 17.9691C14.9496 18.2148 14.4254 18.2148 14 17.9691L12.1893 16.9237C11.7639 16.6781 11.5018 16.2242 11.5018 15.7329V13.6421C11.5018 13.1509 11.7639 12.697 12.1893 12.4513L14 11.4059ZM13.0018 13.7143V15.6608L14.6875 16.634L16.3732 15.6608V13.7143L14.6875 12.7411L13.0018 13.7143Z'
        fill={color}
      />
    </svg>
  )
}
export const BulkOperationIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M17.5405 4.84783C17.978 4.84783 18.3359 5.20579 18.3359 5.64329V17.5751C18.3359 18.4501 17.62 19.166 16.745 19.166H4.81321C4.37571 19.166 4.01776 18.8081 4.01776 18.3706C4.01776 17.9331 4.37571 17.5751 4.81321 17.5751H15.9496C16.3871 17.5751 16.745 17.2172 16.745 16.7797V5.64329C16.745 5.20579 17.103 4.84783 17.5405 4.84783ZM2.42685 1.66602H13.5632C14.4382 1.66602 15.1541 2.38192 15.1541 3.25692V14.3933C15.1541 15.2683 14.4382 15.9842 13.5632 15.9842H2.42685C1.55185 15.9842 0.835938 15.2683 0.835938 14.3933V3.25692C0.835938 2.38192 1.55185 1.66602 2.42685 1.66602ZM3.2223 14.3933H12.7678C13.2053 14.3933 13.5632 14.0353 13.5632 13.5978V4.05238C13.5632 3.61488 13.2053 3.25692 12.7678 3.25692H3.2223C2.7848 3.25692 2.42685 3.61488 2.42685 4.05238V13.5978C2.42685 14.0353 2.7848 14.3933 3.2223 14.3933Z'
          fill={color}
        />
        <path
          d='M8.03654 5.10569L5.9493 7.19293C5.70991 7.43233 5.87449 7.83631 6.21114 7.83631H7.55027V11.5769C7.55027 11.9883 7.88692 12.325 8.29838 12.325C8.70985 12.325 9.0465 11.9883 9.0465 11.5769V7.83631H10.3856C10.7223 7.83631 10.8869 7.43233 10.6475 7.20041L8.56023 5.11317C8.41808 4.96355 8.17869 4.96355 8.03654 5.10569Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_17282_90751'>
          <rect width='20' height='20' fill='white' transform='matrix(-1 0 0 1 20 0)' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const UserManagementIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clipPath='url(#clip0_1628_4437)'>
        <path
          d='M7.49984 9.79163C6.92484 9.79163 6.45817 10.2583 6.45817 10.8333C6.45817 11.4083 6.92484 11.875 7.49984 11.875C8.07484 11.875 8.5415 11.4083 8.5415 10.8333C8.5415 10.2583 8.07484 9.79163 7.49984 9.79163ZM12.4998 9.79163C11.9248 9.79163 11.4582 10.2583 11.4582 10.8333C11.4582 11.4083 11.9248 11.875 12.4998 11.875C13.0748 11.875 13.5415 11.4083 13.5415 10.8333C13.5415 10.2583 13.0748 9.79163 12.4998 9.79163ZM9.99984 1.66663C5.39984 1.66663 1.6665 5.39996 1.6665 9.99996C1.6665 14.6 5.39984 18.3333 9.99984 18.3333C14.5998 18.3333 18.3332 14.6 18.3332 9.99996C18.3332 5.39996 14.5998 1.66663 9.99984 1.66663ZM9.99984 16.6666C6.32484 16.6666 3.33317 13.675 3.33317 9.99996C3.33317 9.75829 3.34984 9.51663 3.37484 9.28329C5.3415 8.40829 6.89984 6.79996 7.7165 4.80829C9.22484 6.94163 11.7082 8.33329 14.5165 8.33329C15.1665 8.33329 15.7915 8.25829 16.3915 8.11663C16.5665 8.70829 16.6665 9.34163 16.6665 9.99996C16.6665 13.675 13.6748 16.6666 9.99984 16.6666Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_1628_4437'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const AssociatedUsersIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 16 16' fill='none'>
      <path
        d='M12.0026 14.0003C12.0026 12.5858 11.4407 11.2293 10.4405 10.2291C9.44031 9.22889 8.08376 8.66699 6.66927 8.66699C5.25478 8.66699 3.89823 9.22889 2.89803 10.2291C1.89784 11.2293 1.33594 12.5858 1.33594 14.0003'
        stroke={color ? color : '#3E3F40'}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66927 8.66667C8.51022 8.66667 10.0026 7.17428 10.0026 5.33333C10.0026 3.49238 8.51022 2 6.66927 2C4.82832 2 3.33594 3.49238 3.33594 5.33333C3.33594 7.17428 4.82832 8.66667 6.66927 8.66667Z'
        stroke={color ? color : '#3E3F40'}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6698 13.3335C14.6698 11.0868 13.3365 9.00013 12.0031 8.00013C12.4414 7.67131 12.7919 7.23952 13.0235 6.74298C13.2551 6.24643 13.3608 5.70044 13.3311 5.15333C13.3015 4.60622 13.1374 4.07485 12.8534 3.60626C12.5695 3.13767 12.1744 2.7463 11.7031 2.4668'
        stroke={color ? color : '#3E3F40'}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const MetaMasterIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M18.0303 16.7803C17.7374 17.0732 17.2625 17.0732 16.9696 16.7803L15.75 15.5607V16.0594C15.75 16.4736 15.4142 16.8094 15 16.8094C14.5858 16.8094 14.25 16.4736 14.25 16.0594V13.75C14.25 13.3358 14.5858 13 15 13H17.3094C17.7236 13 18.0594 13.3358 18.0594 13.75C18.0594 14.1642 17.7236 14.5 17.3094 14.5H16.8106L18.0303 15.7197C18.3232 16.0126 18.3232 16.4874 18.0303 16.7803Z'
        fill={color}
      />
      <path
        d='M1.75 5C1.75 3.89543 2.64543 3 3.75 3H16.25C17.3546 3 18.25 3.89543 18.25 5V10.7812C18.25 11.1955 17.9142 11.5312 17.5 11.5312C17.0858 11.5312 16.75 11.1955 16.75 10.7812V5C16.75 4.72386 16.5261 4.5 16.25 4.5H3.75C3.47386 4.5 3.25 4.72386 3.25 5V15C3.25 15.2761 3.47386 15.5 3.75 15.5H11.875C12.2892 15.5 12.625 15.8358 12.625 16.25C12.625 16.6642 12.2892 17 11.875 17H3.75C2.64543 17 1.75 16.1046 1.75 15V5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.97043 7.54071C7.92191 7.50169 7.86897 7.46911 7.81302 7.44345C7.71029 7.3962 7.60203 7.37413 7.49542 7.37486C7.39383 7.3754 7.29092 7.39666 7.1929 7.44073C7.1271 7.47021 7.06535 7.50922 7.00994 7.55699C6.93112 7.62488 6.86871 7.70741 6.82479 7.79833L4.95416 11.5396C4.76892 11.9101 4.91909 12.3606 5.28957 12.5458C5.66005 12.7311 6.11056 12.5809 6.2958 12.2104L6.40887 11.9843C6.45844 11.9946 6.50981 12 6.56244 12H8.59892L8.70413 12.2104C8.88937 12.5809 9.33987 12.7311 9.71036 12.5458C10.0808 12.3606 10.231 11.9101 10.0458 11.5396L8.1753 7.79866C8.12781 7.70022 8.05864 7.61159 7.97043 7.54071ZM7.151 10.5L7.49996 9.8021L7.84892 10.5H7.151Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.4999 12.625C13.9497 12.625 15.1249 11.4498 15.1249 10C15.1249 8.55027 13.9497 7.37502 12.4999 7.37502H11.6187C11.1734 7.37502 10.8124 7.73599 10.8124 8.18127V11.8188C10.8124 12.264 11.1734 12.625 11.6187 12.625H12.4999ZM12.4999 8.87502C13.1213 8.87502 13.6249 9.3787 13.6249 10C13.6249 10.6213 13.1213 11.125 12.4999 11.125H12.3124V8.87502H12.4999Z'
        fill={color}
      />
    </svg>
  )
}
export const AuditLogsIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.875 3.23665C1.875 2.48463 2.48463 1.875 3.23665 1.875H11.9017C12.6538 1.875 13.2634 2.48463 13.2634 3.23665V6.95026C13.2634 7.36045 12.9309 7.69298 12.5207 7.69298C12.1105 7.69298 11.7779 7.36045 11.7779 6.95026V3.36044H3.36044V15.4915H8.18813C8.59832 15.4915 8.93085 15.8241 8.93085 16.2343C8.93085 16.6445 8.59832 16.977 8.18813 16.977H3.23665C2.48463 16.977 1.875 16.3674 1.875 15.6153V3.23665Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.96967 6.33132C4.96967 5.92113 5.3022 5.5886 5.71239 5.5886H9.42599C9.83619 5.5886 10.1687 5.92113 10.1687 6.33132C10.1687 6.74152 9.83619 7.07404 9.42599 7.07404H5.71239C5.3022 7.07404 4.96967 6.74152 4.96967 6.33132Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.96967 9.42599C4.96967 9.0158 5.3022 8.68327 5.71239 8.68327H6.95026C7.36045 8.68327 7.69298 9.0158 7.69298 9.42599C7.69298 9.83619 7.36045 10.1687 6.95026 10.1687H5.71239C5.3022 10.1687 4.96967 9.83619 4.96967 9.42599Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.7212 10.9367C13.1568 11.2574 12.0527 11.8112 10.8527 11.9781C10.9762 12.9516 11.2311 13.6811 11.6633 14.3515C12.1078 15.0409 12.7649 15.7071 13.7546 16.5174C14.6577 15.7654 15.2785 15.1352 15.7216 14.4552C16.1563 13.7879 16.4435 13.0357 16.6217 12.0099C15.3251 11.8773 14.2705 11.2943 13.7291 10.9388L13.7266 10.9378L13.7212 10.9367ZM12.9927 9.64223C13.4855 9.36175 14.0899 9.39868 14.5444 9.69705C14.9965 9.99392 15.8289 10.4424 16.7998 10.5348C17.5009 10.6016 18.2545 11.2309 18.1061 12.14C17.9037 13.3804 17.5516 14.3674 16.9662 15.266C16.3879 16.1536 15.6074 16.915 14.6126 17.7357C14.1178 18.1438 13.4035 18.1457 12.9064 17.7424C11.8233 16.8636 10.9986 16.0617 10.4149 15.1564C9.82127 14.2358 9.50351 13.2505 9.36437 12.0433C9.26514 11.1823 9.96478 10.5975 10.6227 10.5102C11.5544 10.3867 12.4783 9.93497 12.9927 9.64223Z'
        fill={color}
      />
    </svg>
  )
}
export const ReportIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.125 6.875C6.125 6.11561 6.74061 5.5 7.5 5.5H16.25C17.0094 5.5 17.625 6.11561 17.625 6.875V16.875C17.625 17.6344 17.0094 18.25 16.25 18.25H7.5C6.74061 18.25 6.125 17.6344 6.125 16.875V6.875ZM7.625 7V16.75H16.125V7H7.625Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.25 9.375C9.25 8.96079 9.58579 8.625 10 8.625H13.75C14.1642 8.625 14.5 8.96079 14.5 9.375C14.5 9.78921 14.1642 10.125 13.75 10.125H10C9.58579 10.125 9.25 9.78921 9.25 9.375Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.25 11.875C9.25 11.4608 9.58579 11.125 10 11.125H13.75C14.1642 11.125 14.5 11.4608 14.5 11.875C14.5 12.2892 14.1642 12.625 13.75 12.625H10C9.58579 12.625 9.25 12.2892 9.25 11.875Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.25 14.375C9.25 13.9608 9.58579 13.625 10 13.625H13.75C14.1642 13.625 14.5 13.9608 14.5 14.375C14.5 14.7892 14.1642 15.125 13.75 15.125H10C9.58579 15.125 9.25 14.7892 9.25 14.375Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.375 3.75C2.375 2.64543 3.27043 1.75 4.375 1.75H11.875C12.2892 1.75 12.625 2.08579 12.625 2.5C12.625 2.91421 12.2892 3.25 11.875 3.25H4.375C4.09886 3.25 3.875 3.47386 3.875 3.75V13.75C3.875 14.1642 3.53921 14.5 3.125 14.5C2.71079 14.5 2.375 14.1642 2.375 13.75V3.75Z'
        fill={color}
      />
    </svg>
  )
}
export const EditIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
      <path
        d='M10.2186 1.96287C10.0053 1.76474 9.72264 1.65862 9.43171 1.66751C9.14078 1.6764 8.86508 1.79959 8.66437 2.01038L1.87749 8.79725L1.6671 12.0957C1.66511 12.1274 1.66989 12.1592 1.68112 12.1889C1.69236 12.2186 1.70979 12.2456 1.73225 12.2681C1.75472 12.2905 1.78171 12.308 1.81143 12.3192C1.84115 12.3304 1.87292 12.3352 1.90464 12.3332L5.20306 12.1228L11.9899 5.33595C12.2007 5.13523 12.3239 4.85953 12.3328 4.5686C12.3417 4.27768 12.2356 3.99497 12.0374 3.78175L10.2186 1.96287Z'
        stroke='#402080'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const SegmentManagementIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M15.2865 5.77112L15.2863 5.77097C15.0513 5.47712 15.0736 5.06784 15.3373 4.80415C15.6462 4.49522 16.1595 4.51879 16.4297 4.86196L16.4302 4.86262C17.8882 6.68304 18.6367 9.15245 18.0524 11.7532C17.3359 14.9401 14.8658 17.3855 11.6707 18.069L11.6705 18.069C6.23835 19.2378 1.48653 14.9015 1.7831 9.50559L1.7831 9.50553C2.02184 5.1095 5.82622 1.60209 10.2379 1.7667L10.2379 1.76677H10.2416C10.5114 1.76677 10.7332 1.98867 10.7332 2.25844V8.56677V8.62504L10.7839 8.65377C11.2537 8.91995 11.5666 9.42065 11.5666 10.0001C11.5666 10.8615 10.8614 11.5668 9.99992 11.5668C9.13848 11.5668 8.43325 10.8615 8.43325 10.0001C8.43325 9.42142 8.74555 8.92814 9.21697 8.65315L9.26658 8.62421V8.56677V6.78344V6.65391L9.14127 6.68669C7.66589 7.0727 6.56658 8.40264 6.56658 10.0001C6.56658 12.1544 8.54111 13.8367 10.7713 13.3478L10.7715 13.3477C11.9741 13.0814 12.961 12.1461 13.296 10.9693C13.5962 9.92315 13.3903 8.91001 12.8753 8.12048C12.682 7.82283 12.7073 7.43417 12.954 7.18748L12.9615 7.17997C12.9616 7.17984 12.9617 7.17972 12.9619 7.17959C13.2813 6.86805 13.8148 6.89759 14.0588 7.25617C14.5897 8.04025 14.8999 8.97917 14.8999 10.0001C14.8999 12.9075 12.36 15.2267 9.38719 14.8592L9.38704 14.8592C7.24807 14.5979 5.47552 12.8823 5.15717 10.7521C4.74875 7.99938 6.62682 5.60658 9.18328 5.1737L9.26658 5.15959V5.0751V3.39177V3.2786L9.15427 3.29253C5.81317 3.707 3.23325 6.54898 3.23325 10.0001C3.23325 14.1691 7.01354 17.5026 11.3277 16.6482L11.328 16.6481C13.8913 16.1321 15.9123 14.2032 16.5801 11.6252C17.1557 9.41559 16.5115 7.30881 15.2865 5.77112Z'
        fill='#4C4C4C'
      />
      <defs>
        <clipPath id='clip0_2574_5554'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const BoltMasterIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path
        d='M8.53439 0.192879C8.79157 -0.064293 9.20847 -0.064293 9.46565 0.192879L12.5388 3.26605C12.796 3.52323 12.796 3.94019 12.5388 4.19737L9.46565 7.27051C9.20847 7.5277 8.79157 7.5277 8.53439 7.27051L5.46119 4.19737C5.20402 3.94019 5.20402 3.52323 5.46119 3.26605L8.53439 0.192879ZM6.85816 3.73171L9.00002 5.87357L11.1418 3.73171L9.00002 1.58985L6.85816 3.73171Z'
        fill='#4C4C4C'
      />
      <path
        d='M8.53439 10.7295C8.79157 10.4723 9.20847 10.4723 9.46565 10.7295L12.5388 13.8027C12.796 14.0599 12.796 14.4768 12.5388 14.7339L9.46565 17.8071C9.20847 18.0643 8.79157 18.0643 8.53439 17.8071L5.46119 14.7339C5.20402 14.4768 5.20402 14.0599 5.46119 13.8027L8.53439 10.7295ZM6.85816 14.2683L9.00002 16.4101L11.1418 14.2683L9.00002 12.1265L6.85816 14.2683Z'
        fill='#4C4C4C'
      />
      <path
        d='M13.8027 5.46095C14.0599 5.20377 14.4768 5.20377 14.7339 5.46095L17.8071 8.53415C18.0643 8.79133 18.0643 9.20823 17.8071 9.46541L14.7339 12.5386C14.4768 12.7958 14.0599 12.7958 13.8027 12.5386L10.7295 9.46541C10.4723 9.20823 10.4723 8.79133 10.7295 8.53415L13.8027 5.46095ZM12.1265 8.99978L14.2683 11.1416L16.4101 8.99978L14.2683 6.85791L12.1265 8.99978Z'
        fill='#4C4C4C'
      />
      <path
        d='M3.26605 5.46095C3.52323 5.20377 3.94019 5.20377 4.19737 5.46095L7.27051 8.53415C7.5277 8.79133 7.5277 9.20823 7.27051 9.46541L4.19737 12.5386C3.94019 12.7958 3.52323 12.7958 3.26605 12.5386L0.192879 9.46541C-0.064293 9.20823 -0.064293 8.79133 0.192879 8.53415L3.26605 5.46095ZM1.58985 8.99978L3.73171 11.1416L5.87357 8.99978L3.73171 6.85791L1.58985 8.99978Z'
        fill='#4C4C4C'
      />
    </svg>
  )
}

export const ManageWidgetIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M9.99993 12.6381C9.09288 12.6381 8.18614 12.4164 7.35929 11.9729L1.39712 8.77483C0.532555 8.31114 -0.0026909 7.41439 0.00011869 6.4346C0.00296574 5.4548 0.543418 4.5612 1.41064 4.10245L7.38784 0.940839C9.02347 0.07571 10.9764 0.07571 12.612 0.940839L18.5892 4.10245C19.4564 4.56116 19.9969 5.45476 19.9997 6.4346C20.0026 7.41439 19.4673 8.31114 18.6028 8.77483L12.6405 11.9729C11.814 12.4164 10.9068 12.638 9.99993 12.6381ZM9.99993 1.85463C9.35369 1.85463 8.70748 2.01043 8.11841 2.32203L2.14129 5.48368C1.78016 5.6747 1.56382 6.03193 1.56266 6.43917C1.5615 6.84641 1.7757 7.20487 2.13574 7.39798L8.09795 10.596C9.28903 11.2349 10.7111 11.2349 11.9021 10.596L17.8643 7.39798C18.2244 7.20487 18.4386 6.84644 18.4374 6.43917C18.4363 6.03189 18.2199 5.6747 17.8588 5.48368L11.8815 2.32203C11.2924 2.01047 10.6462 1.85463 9.99993 1.85463ZM12.6406 19.0431L19.5878 15.3168C19.9681 15.1129 20.111 14.6393 19.907 14.2591C19.7031 13.8789 19.2295 13.736 18.8493 13.9399L11.902 17.6662C10.7111 18.305 9.28899 18.305 8.09488 17.6646L1.14763 13.9774C0.766425 13.7751 0.293552 13.9201 0.0913367 14.3012C-0.110954 14.6823 0.0340211 15.1552 0.415151 15.3575L7.35933 19.0431C8.18617 19.4866 9.09292 19.7083 9.99997 19.7083C10.9068 19.7083 11.814 19.4865 12.6406 19.0431ZM12.6406 15.5275L19.5878 11.8013C19.9681 11.5973 20.111 11.1238 19.907 10.7436C19.7031 10.3633 19.2295 10.2205 18.8493 10.4244L11.902 14.1506C10.7111 14.7895 9.28899 14.7895 8.09488 14.149L1.14763 10.4618C0.766425 10.2595 0.293552 10.4045 0.0913367 10.7856C-0.110954 11.1668 0.0340211 11.6396 0.415151 11.8419L7.35933 15.5275C8.18617 15.971 9.09292 16.1927 9.99997 16.1927C10.9068 16.1927 11.814 15.971 12.6406 15.5275Z'
        fill='#4C4C4C'
      />
      <defs>
        <clipPath id='clip0_5961_13811'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ManageContainerIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M12.0972 0.781143L12.0926 0.776679C12.0085 0.689904 11.8924 0.641356 11.7713 0.642751C11.7564 0.642053 11.7413 0.643448 11.7267 0.647354H4.87123C3.63895 0.647633 2.64021 1.64651 2.63965 2.87893V17.161C2.64021 18.3932 3.63895 19.3921 4.87123 19.3925H14.8108C16.0431 19.3921 17.0419 18.3932 17.0424 17.161V5.90473C17.0415 5.78657 16.9952 5.67315 16.9129 5.58805L12.0972 0.781143ZM12.2176 2.16479L15.5293 5.46751H13.5566C12.818 5.46528 12.2197 4.86707 12.2176 4.12865V2.16479ZM14.8152 18.4955H4.87123C4.13267 18.4934 3.5346 17.8951 3.53222 17.1565V2.87433C3.5346 2.13591 4.13267 1.53756 4.87123 1.53547H11.325V4.12865C11.3254 5.36079 12.3243 6.35967 13.5566 6.36023H16.1498V17.1565C16.1512 17.8948 15.5535 18.4945 14.8152 18.4955Z'
        fill='#3E3F40'
        stroke='#3E3F40'
        strokeWidth='0.25'
      />
      <path
        d='M10.3257 9.18183H5.50098C5.29588 9.18183 5.12969 9.01564 5.12969 8.81055C5.12969 8.60546 5.29588 8.43926 5.50098 8.43926H10.3257C10.5307 8.43926 10.6972 8.6055 10.6972 8.81055C10.6972 9.01559 10.5307 9.18183 10.3257 9.18183Z'
        fill='#3E3F40'
        stroke='#3E3F40'
        strokeWidth='0.15'
      />
      <path
        d='M5.50098 11.8133H14.1864C14.3913 11.8133 14.5578 11.9795 14.5578 12.1846C14.5578 12.3895 14.3913 12.5559 14.1864 12.5559H5.50098C5.2959 12.5559 5.12969 12.3895 5.12969 12.1846C5.12969 11.9795 5.29588 11.8133 5.50098 11.8133Z'
        fill='#3E3F40'
        stroke='#3E3F40'
        strokeWidth='0.15'
      />
      <path
        d='M5.50098 15.1922H14.1864C14.3913 15.1922 14.5578 15.3584 14.5578 15.5635C14.5578 15.7685 14.3913 15.9348 14.1864 15.9348H5.50098C5.29588 15.9348 5.12969 15.7686 5.12969 15.5635C5.12969 15.3584 5.29588 15.1922 5.50098 15.1922Z'
        fill='#3E3F40'
        stroke='#3E3F40'
        strokeWidth='0.15'
      />
    </svg>
  )
}

export const SiteNavigationIcon: React.FC<colortype> = ({ color = '#3E3F40' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g>
        <path
          d='M4.33297 16.667H1.66633C1.48234 16.667 1.33301 16.8163 1.33301 17.0003C1.33301 17.1843 1.48234 17.3336 1.66633 17.3336H4.33301C4.51699 17.3336 4.66633 17.1843 4.66633 17.0003C4.66633 16.8163 4.51699 16.667 4.33297 16.667Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M7.66633 5.33363H12.333C12.5173 5.33363 12.6663 5.1843 12.6663 5.00031C12.6663 4.81633 12.5173 4.66699 12.333 4.66699H7.66633C7.48234 4.66699 7.33301 4.81633 7.33301 5.00031C7.33301 5.1843 7.4823 5.33363 7.66633 5.33363Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M3.00031 12.6667C3.1843 12.6667 3.33363 12.5173 3.33363 12.3334V10.6667H9.66695V12.3334C9.66695 12.5173 9.81629 12.6667 10.0003 12.6667C10.1846 12.6667 10.3336 12.5173 10.3336 12.3334V10.6667H16.6669V12.3334C16.6669 12.5173 16.8159 12.6667 17.0002 12.6667C17.1846 12.6667 17.3336 12.5173 17.3336 12.3334V10.3334C17.3336 10.1494 17.1846 10 17.0002 10H10.3336V7.66672C10.3336 7.48273 10.1846 7.3334 10.0003 7.3334H6.33363C5.7823 7.3334 5.33363 6.88473 5.33363 6.3334V1.66668C5.33363 1.11535 5.7823 0.66668 6.33363 0.66668H13.667C14.2183 0.66668 14.667 1.11535 14.667 1.66668V6.33336C14.667 6.88469 14.2183 7.33336 13.667 7.33336H11.3336C11.1493 7.33336 11.0003 7.4827 11.0003 7.66668C11.0003 7.85066 11.1493 8 11.3336 8H13.667C14.5859 8 15.3336 7.25234 15.3336 6.33332V1.66668C15.3336 0.747656 14.586 0 13.667 0H6.33363C5.41465 0 4.66695 0.747656 4.66695 1.66668V6.33336C4.66695 7.25234 5.41461 8.00004 6.33363 8.00004H9.66695V10H3.00031C2.81633 10 2.66699 10.1493 2.66699 10.3333V12.3333C2.66699 12.5173 2.81633 12.6667 3.00031 12.6667Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M7.66633 3.33363H11.6663C11.8507 3.33363 11.9996 3.1843 11.9996 3.00031C11.9996 2.81633 11.8507 2.66699 11.6663 2.66699H7.66633C7.48234 2.66699 7.33301 2.81633 7.33301 3.00031C7.33301 3.1843 7.4823 3.33363 7.66633 3.33363Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M1.66633 15.9996H2.99965C3.18363 15.9996 3.33297 15.8503 3.33297 15.6663C3.33297 15.4823 3.18363 15.333 2.99965 15.333H1.66633C1.48234 15.333 1.33301 15.4823 1.33301 15.6663C1.33301 15.8503 1.4823 15.9996 1.66633 15.9996Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M5.33332 13.333H0.66668C0.298984 13.333 0 13.632 0 13.9997V19.333C0 19.7007 0.298984 19.9997 0.66668 19.9997H5.33336C5.70102 19.9997 6.00004 19.7007 6.00004 19.333V13.9997C6 13.632 5.70102 13.333 5.33332 13.333ZM0.66668 19.333V13.9997H5.33336L5.33371 19.333H0.66668Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M4.33297 18H1.66633C1.48234 18 1.33301 18.1493 1.33301 18.3333C1.33301 18.5173 1.48234 18.6666 1.66633 18.6666H4.33301C4.51699 18.6666 4.66633 18.5173 4.66633 18.3333C4.66633 18.1493 4.51699 18 4.33297 18Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M18.333 18H15.6663C15.482 18 15.333 18.1493 15.333 18.3333C15.333 18.5173 15.482 18.6666 15.6663 18.6666H18.333C18.5173 18.6666 18.6663 18.5173 18.6663 18.3333C18.6663 18.1493 18.5173 18 18.333 18Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M18.333 16.667H15.6663C15.482 16.667 15.333 16.8163 15.333 17.0003C15.333 17.1843 15.482 17.3336 15.6663 17.3336H18.333C18.5173 17.3336 18.6663 17.1843 18.6663 17.0003C18.6663 16.8163 18.5173 16.667 18.333 16.667Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M19.3333 13.333H14.6667C14.299 13.333 14 13.632 14 13.9997V19.333C14 19.7007 14.299 19.9997 14.6667 19.9997H19.3334C19.701 19.9997 20 19.7007 20 19.333V13.9997C20 13.632 19.701 13.333 19.3333 13.333ZM14.6667 19.333V13.9997H19.3334L19.3337 19.333H14.6667Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M15.6663 15.9996H16.9996C17.184 15.9996 17.333 15.8503 17.333 15.6663C17.333 15.4823 17.184 15.333 16.9996 15.333H15.6663C15.482 15.333 15.333 15.4823 15.333 15.6663C15.333 15.8503 15.482 15.9996 15.6663 15.9996Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M11.333 16.667H8.66633C8.48234 16.667 8.33301 16.8163 8.33301 17.0003C8.33301 17.1843 8.48234 17.3336 8.66633 17.3336H11.333C11.5173 17.3336 11.6663 17.1843 11.6663 17.0003C11.6663 16.8163 11.5173 16.667 11.333 16.667Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M11.333 18H8.66633C8.48234 18 8.33301 18.1493 8.33301 18.3333C8.33301 18.5173 8.48234 18.6666 8.66633 18.6666H11.333C11.5173 18.6666 11.6663 18.5173 11.6663 18.3333C11.6663 18.1493 11.5173 18 11.333 18Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M12.3333 13.333H7.66668C7.29902 13.333 7 13.632 7 13.9997V19.333C7 19.7007 7.29898 19.9997 7.66668 19.9997H12.3334C12.701 19.9997 13 19.7007 13 19.333V13.9997C13 13.632 12.701 13.333 12.3333 13.333ZM7.66668 19.333V13.9997H12.3334L12.3337 19.333H7.66668Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
        <path
          d='M8.66633 15.9996H9.99965C10.184 15.9996 10.333 15.8503 10.333 15.6663C10.333 15.4823 10.184 15.333 9.99965 15.333H8.66633C8.48234 15.333 8.33301 15.4823 8.33301 15.6663C8.33301 15.8503 8.4823 15.9996 8.66633 15.9996Z'
          fill='#3E3F40'
          stroke='#3E3F40'
          strokeWidth='0.15'
        />
      </g>
      <defs>
        <clipPath id='clip0_8574_37174'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
